/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Select_AllInputs */

const en_forms_select_all = /** @type {(inputs: Forms_Select_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select All`)
};

const de_forms_select_all = /** @type {(inputs: Forms_Select_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle auswählen`)
};

const es_forms_select_all = /** @type {(inputs: Forms_Select_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar todo`)
};

const fr_forms_select_all = /** @type {(inputs: Forms_Select_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout sélectionner`)
};

/** @type {(inputs: Forms_Select_AllInputs) => LocalizedString} */
const it_forms_select_all = en_forms_select_all;

/** @type {(inputs: Forms_Select_AllInputs) => LocalizedString} */
const pt_br2_forms_select_all = en_forms_select_all;

/** @type {(inputs: Forms_Select_AllInputs) => LocalizedString} */
const pl_forms_select_all = en_forms_select_all;

/** @type {(inputs: Forms_Select_AllInputs) => LocalizedString} */
const hu_forms_select_all = en_forms_select_all;

/** @type {(inputs: Forms_Select_AllInputs) => LocalizedString} */
const ro_forms_select_all = en_forms_select_all;

/**
* | output |
* | --- |
* | "Select All" |
*
* @param {Forms_Select_AllInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const forms_select_all = /** @type {((inputs?: Forms_Select_AllInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Select_AllInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_select_all(inputs)
	if (locale === "de") return de_forms_select_all(inputs)
	if (locale === "es") return es_forms_select_all(inputs)
	if (locale === "fr") return fr_forms_select_all(inputs)
	if (locale === "it") return it_forms_select_all(inputs)
	if (locale === "pt-BR") return pt_br2_forms_select_all(inputs)
	if (locale === "pl") return pl_forms_select_all(inputs)
	if (locale === "hu") return hu_forms_select_all(inputs)
	return ro_forms_select_all(inputs)
});
export { forms_select_all as "forms.select_all" }